import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { Constant } from "../../Constant";

export const CustomCategoryDropdown = ({ filters, setFilters }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  // Synchronisiere mit den globalen Filtern
  useEffect(() => {
    const category = Constant.NEW_CATEGORY.find(cat => cat.value === filters.category);
    setSelectedCategory(category || null);
    
    if (category && filters.sub_category) {
      const subCategory = category.sub?.find(sub => sub.value === filters.sub_category);
      setSelectedSubCategory(subCategory || null);
    } else {
      setSelectedSubCategory(null);
    }
  }, [filters.category, filters.sub_category]);

  // Schließe Dropdown beim Klick außerhalb
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        // Prüfe auch, ob der Klick im Portal-Dropdown war
        const portalElement = document.getElementById('category-dropdown-portal');
        if (portalElement && !portalElement.contains(event.target)) {
          setIsOpen(false);
        } else if (!portalElement) {
          setIsOpen(false);
        }
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [isOpen]);

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setSelectedSubCategory(null);
    
    setFilters(prev => ({
      ...prev,
      category: category.value,
      sub_category: ""
    }));
  };

  const handleSubCategorySelect = (subCategory) => {
    setSelectedSubCategory(subCategory);
    
    setFilters(prev => ({
      ...prev,
      sub_category: subCategory.value
    }));
    
    setIsOpen(false);
  };

  const handleToggleDropdown = () => {
    if (!isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + 8,
        left: rect.left,
      });
    }
    setIsOpen(!isOpen);
  };

  const getDisplayText = () => {
    if (selectedSubCategory) {
      return selectedSubCategory.label;
    }
    if (selectedCategory) {
      return selectedCategory.label;
    }
    return "Kategorie";
  };

  return (
    <>
      <div className="relative" ref={dropdownRef}>
        <button
          ref={buttonRef}
          onClick={handleToggleDropdown}
          className="text-primary font-light font-helvetica bg-inherit focus:outline-none border-none flex items-center gap-2 min-w-0 truncate"
        >
          <span className="truncate">{getDisplayText()}</span>
          <svg 
            className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      </div>

      {isOpen && createPortal(
        <div 
          id="category-dropdown-portal"
          className="fixed z-[9999] bg-white border border-gray-200 rounded-md shadow-lg overflow-hidden"
          style={{
            top: `${dropdownPosition.top}px`,
            left: `${dropdownPosition.left}px`,
          }}
        >
            <div className="flex">
            {/* Kategorien-Liste */}
            <div className={`${selectedCategory && selectedCategory.sub && selectedCategory.sub.length > 0 ? 'border-r border-gray-200' : ''} bg-white min-w-0`}>
              <div className="max-h-[250px] overflow-y-auto">
                {Constant.NEW_CATEGORY.map((category, idx) => (
                  <button
                    key={idx}
                    onClick={() => handleCategorySelect(category)}
                    className={`w-full text-left px-3 py-2 text-sm font-helvetica hover:bg-gray-100 transition-colors whitespace-nowrap block ${
                      selectedCategory?.value === category.value 
                        ? 'bg-lightGreen text-primary font-medium' 
                        : 'text-primary'
                    }`}
                  >
                    {category.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Unterkategorien-Liste - nur wenn Kategorie ausgewählt UND Unterkategorien vorhanden */}
            {selectedCategory && selectedCategory.sub && selectedCategory.sub.length > 0 && (
              <div className="bg-white min-w-0">
                <div className="max-h-[250px] overflow-y-auto">
                  {selectedCategory.sub.map((subCategory, idx) => (
                    <button
                      key={idx}
                      onClick={() => handleSubCategorySelect(subCategory)}
                      className={`w-full text-left px-3 py-2 text-sm font-helvetica hover:bg-gray-100 transition-colors whitespace-nowrap block ${
                        selectedSubCategory?.value === subCategory.value 
                          ? 'bg-lightGreen text-primary font-medium' 
                          : 'text-gray-600'
                      }`}
                    >
                      {subCategory.label}
                    </button>
                  ))}
                </div>
              </div>
            )}
            </div>
        </div>,
        document.body
      )}
    </>
  );
};